<template>
<v-app>
    <v-content>
      <div class="login">
        <img src="../assets/PEC-Logo-1.png" width="300px">
        
        <v-form align-center>
          <v-container fluid>
            <h3>PEC DMV Area</h3>
            <v-layout align-center justify-center>
              <v-flex
                xs12
                md3>
                <v-text-field 
                type="text" 
                v-model="email" 
                label="Email address" 
                required></v-text-field>
              </v-flex>
              <v-flex
                xs12
                md3>
                <v-text-field 
                  type="password" 
                  v-model="password"
                  label="Password" 
                  required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        
        <br/>
        <v-btn v-on:click="login" class="button">Enter</v-btn>
        <p><router-link to="/signup">
          New Here? Create a new account
        </router-link></p>
      </div>
    </v-content>
</v-app>
  
</template>

<script>
  import firebase from 'firebase'
  
  export default {
    name: 'login',
    data: function() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      login () {
        firebase.auth().signInWithEmailAndPassword(this.email, 
            this.password).then((user) => {
          this.$router.replace('/people')
        }).catch((err) => {
          alert(err.message)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue